import React from 'react';
import { FollowUs } from '@kambria/kambria-lego';
import { Footer as LegoFooter } from '@kambria/kambria-lego';

import mediumIcon from 'static/images/footer/medium.png';
import telegramIcon from 'static/images/footer/telegram.png';
import facebookIcon from 'static/images/footer/facebook.png';
import twitterIcon from 'static/images/footer/twitter.png';
import linkedinIcon from 'static/images/footer/linkedin.png';
import youtubeIcon from 'static/images/footer/youtube.png';
import instagramIcon from 'static/images/footer/instagram.png';

class Footer extends React.Component {
  constructor() {
    super();

    this.state = {
      followUs: [
        { name: 'Medium', url: 'https://medium.com/kambria-network', icon: mediumIcon },
        { name: 'Telegram', url: 'https://t.me/kambriaofficial', icon: telegramIcon },
        { name: 'Facebook', url: 'https://www.facebook.com/KambriaNetwork', icon: facebookIcon },
        { name: 'Twitter', url: 'https://twitter.com/KambriaNetwork', icon: twitterIcon },
        { name: 'Linkedin', url: 'https://www.linkedin.com/company/kambria/', icon: linkedinIcon },
        { name: 'Youtube', url: 'https://www.youtube.com/channel/UCSVHcYVKbZQ4DRzuCItarrQ/featured', icon: youtubeIcon },
        { name: 'Instagram', url: 'https://www.instagram.com/kambrianetwork/', icon: instagramIcon },
      ]
    }
  }
  render() {
    return <LegoFooter><FollowUs data={this.state.followUs} /></LegoFooter>
  }
}

export default Footer;